<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3">ACKNOWLEDGMENTS</h1>
<p class="image"><img alt="Image" src="images/s.jpg"/></p>
<p class="para0">T<span class="smallcaps">HE</span> <span class="smallcaps">INSPIRATION FOR THIS</span> anthology came from my children Ari, Judy and Miriam and their respective spouses Kate, Steven and Mark. At a “milestone” birthday party, they presented me with a booklet of clippings of stories I had written and which subsequently formed the basis for this book. My daughter Judy merits a special mention because it was her work that was the springboard for the book. My wife Chaya, of course, has my gratitude and love for her patience, understanding and encouragement in bringing this project to fruition.</p>
<p class="indent-para">My special thanks go to Irwin Suloway, Joe Kraus and Bev Chubat who, as editors of <em>Chicago Jewish History</em> during the times when these stories were published, were of immeasurable assistance in helping to edit my material.</p>
<p class="indent-para">My gratitude is extended to my publishers, Anita and Jordan Miller of Academy Chicago Publishers, whose editing and patience (sprinkled with humor) have been inspiring, and to Sarah Olson for her first-rate design and production of the book. Finally, the Chicago Jewish Historical Society and a number of its members, particularly Norman Schwartz and Charles Bernstein, have been extremely helpful with their advice and assistance in the research necessary to unfold these stories. The entire CJHS has my gratitude.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Acknowledgments.vue?d91ae75e